<template>
  <div class="air-upload-excel flex vertical">
    <div class="upload-container">
      <el-upload
          ref="upload"
          drag
          :limit="1"
          accept=".xls,.xlsx"
          :action="uploadUrl"
          :file-list="fileList"
          :before-upload="beforeFileUpload"
          :on-success="fileUploadSuccess"
          :on-error="fileUploadError"
          :on-remove="handleRemove"
      >
        <div class="upload-body flex vertical acenter">
          <img src="@/air/assets/img/icon/excel.png" />
          <el-button plain class="button-v2">上传文件</el-button>
          <span class="upload-tips">将文件拖到此处或点击上传，仅支持xls或xlsx文件。</span>
        </div>
      </el-upload>
    </div>
    <div class="flex vertical">
      <div class="flex acenter">
        <span class="font-14 text-left text-nowrap" style="width: 135px;">请选择上传sheet页：</span>
        <el-select v-model="uploadExcelInfo.sheetName" @change="changeSheet"
                   :disabled="sheetDisabled">
          <el-option v-for="sheet in sheetNameList" :key="sheet.sheetName" :label="sheet.sheetName" :value="sheet.sheetName"></el-option>
        </el-select>
      </div>
      <div class="flex acenter mt10">
        <span class="font-14 text-left" style="width: 135px;">请输入表头所在行：</span>
        <el-input-number class="input-text-center wpx60" v-model="uploadExcelInfo.headerRow" :min="1" :max="headerRowMax" :controls="false" :precision="0" :disabled="sheetDisabled" @blur="blurHeaderRow" ></el-input-number>
        <span class="font-14 ml5">行（最大行数{{ headerRowMax }}）</span>
      </div>
    </div>
  </div>

</template>

<script>
import { getSheetName } from "@/api/wage/batchTemplate"

export default {
  name: "AirUploadExcel",
  props: {},
  computed: {},
  data() {
    return {
      fileList: [],
      uploadUrl: '/api/file', //上传地址
      loading: false,
      //记录上传的文件返回的id和文件名
      uploadExcelInfo: {
        fileId: '', //上传文件返回的id
        fileName: '', //上传文件返回的文件名
        sheetName: '', //所选sheet页名
        headerRow: 1 //数据有效行默认第一行
      },
      sheetNameList: [], //获取上传文件的sheet页
      sheetRowMap: {}, //获取上传文件在每个sheet页里的有效行
      sheetDisabled: true, //默认sheet不能选择，上传成功后可选择
      headerRowMax: 1 //表头行最大值
    }
  },
  created() {
  },
  methods: {
    blurHeaderRow() {
      this.uploadExcelInfo.headerRow = this.uploadExcelInfo.headerRow || 1
      this.$emit('get-upload-info', this.uploadExcelInfo)
    },
    changeSheet(value) {
      this.uploadExcelInfo.sheetName = value
      this.uploadExcelInfo.headerRow = 1
      this.headerRowMax = this.sheetRowMap[value]
      this.$emit('get-upload-info', this.uploadExcelInfo)
    },
    reset() {
      this.uploadExcelInfo = {
        fileId: '',
        fileName: '',
        sheetName: '',
        headerRow: 1
      }
      this.sheetNameList = []
      this.sheetRowMap = {}
      this.sheetDisabled = true
      this.headerRowMax = 1
    },
    beforeFileUpload(file) {
      this.reset()
      const isxls = file.type === "application/vnd.ms-excel"
      const isxlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      const isExceed = file.size / 1024 / 1024 > 10

      if (!isxls && !isxlsx) {
        this.$msgError("导入文件只能是 xls,xlsx 格式!")
        return false
      }
      if (isExceed) {
        this.$msgError("导入文件大小不能超过 10MB!")
        return false
      }
      return true
    },
    fileUploadSuccess(res, file, fileList) {
      if (!res) {
        this.$msgError('文件上传失败！')
        return
      }
      this.uploadExcelInfo.fileId = file.response.fileId
      this.uploadExcelInfo.fileName = file.response.fileName
      // 获取sheet信息
      getSheetName(this.uploadExcelInfo).then(res => {
        if (res.data.code === 0) {
          this.sheetNameList = res.data.data.sheetCode
          this.sheetRowMap = res.data.data.headerList
          this.uploadExcelInfo.sheetName = this.sheetNameList[0].sheetName
          this.headerRowMax = this.sheetRowMap[this.uploadExcelInfo.sheetName]
          this.sheetDisabled = false
          this.$msgSuccess('上传成功，请选择sheet页和表头所在行')
          this.$emit('get-upload-info', this.uploadExcelInfo)
        } else {
          this.sheetDisabled = true
          this.$msgError(res.data.msg)
        }
      })
    },
    fileUploadError(err, file, fileList) {
      this.sheetDisabled = true
      this.$msgError("文件上传异常!")
    },
    handleRemove(file, fileList) {
      if (!fileList.length) {
        this.reset()
      }
      this.$emit('get-upload-info', this.uploadExcelInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.air-upload-excel {
  .upload-container {
    width: 100%;
    background: #FFFFFF;
    border-radius: 6px;
    padding: 16px 0;

    .el-upload {
      width: 100%;

      .el-upload-dragger {
        width: 100%;
        height: 165px;
      }
      .upload-body {
        img {
          width: 31px;
          height: 32px;
          margin-top: 30px;
          margin-bottom: 14px;
        }
        .upload-tips {
          height: 14px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3E475D;
          line-height: 14px;
          margin-top: 20px;
        }
      }
    }
    .upload-require-tips {
      margin-top: 16px;
      margin-bottom: 19px;

      span {
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3E475D;
        line-height: 16px;
      }
    }
    ::v-deep .el-upload-list__item-name {
      text-align: left;
    }
  }
}
</style>
